//import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { Button } from '../Button/Button';
import { Select } from '../Select/Select';
import './GettingStarted.scss';

import Image from '../../assets/getting-started.svg';

export interface GettingStartedProps {
  gettingStartedProducts: any;
  boardData: any;
  selectOptions: any;
  selectedBoard: any;
  setSelectedBoardCompatibility: (selectedBoardCompatibility: any) => void;
  setSelectedBoard: (selectedBoard: any) => void;
  setOpenGettingStartedModal: (value: boolean) => void;
}

export default function GettingStarted(props: GettingStartedProps): React.ReactElement {
  const {
    gettingStartedProducts,
    boardData,
    selectOptions,
    selectedBoard,
    setSelectedBoardCompatibility,
    setSelectedBoard,
    setOpenGettingStartedModal,
  } = props;

  return (
    <div className="getting-started">
      <div className="getting-started__image">
        {/* <StaticImage src="../../assets/getting-started.png" alt="getting-started" /> */}
        <img src={Image} alt="getting-started" />
      </div>

      <div className="getting-started__content">
        <h2>Set Up Your Arduino Board</h2>
        <p>
          Set up your Arduino board with this interactive tutorial. Don’t have any Arduino hardware yet? Have a look at our{' '}
          <a href="https://store.arduino.cc/">Store</a>!
        </p>
        <Select
          className="getting-started__input"
          onChange={(value) => {
            const selectedBoard = gettingStartedProducts.find((b) => b.node.fields.slug === value);
            const selectedBoardCompatibility = boardData.compatibilities.edges.find(
              (c) => c.node.relativeDirectory === selectedBoard.node.relativeDirectory
            );
            setSelectedBoardCompatibility(selectedBoardCompatibility);
            setSelectedBoard(selectedBoard);
          }}
          onBlur={() => null}
          options={selectOptions}
          defaultValue={null}
          isRequired
        />
        <div className="getting-started__button-wrapper">
          <Button variant="primary" isDisabled={!selectedBoard} onClick={() => setOpenGettingStartedModal(true)}>
            GET STARTED
          </Button>
        </div>
      </div>
    </div>
  );
}
